// ================================
// VAREK — Effet survol montre
// Fichier : assets/varek-hover-effect.js
// ================================

document.addEventListener('DOMContentLoaded', function () {

  // Cibler toutes les images de produits montre
  const watchImages = document.querySelectorAll(
    '.product__media img, .card__media img, .hero__media img, [class*="product"] img'
  );

  watchImages.forEach(function (img) {
    const wrapper = img.closest('.product__media, .card__media, .hero__media, [class*="product-card"]');
    if (!wrapper) return;

    // Creer l'overlay SVG aiguilles
    const overlay = document.createElement('div');
    overlay.className = 'varek-watch-overlay';
    overlay.innerHTML = `
      <svg class="varek-clock-svg" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
        <!-- Cercle cadran -->
        <circle cx="100" cy="100" r="80" fill="none" stroke="rgba(180,150,90,0.4)" stroke-width="1"/>
        <circle cx="100" cy="100" r="70" fill="none" stroke="rgba(180,150,90,0.2)" stroke-width="0.5"/>
        <!-- Index 12h -->
        <line x1="100" y1="22" x2="100" y2="34" stroke="rgba(180,150,90,0.7)" stroke-width="2" stroke-linecap="round"/>
        <!-- Index 3h -->
        <line x1="166" y1="100" x2="154" y2="100" stroke="rgba(180,150,90,0.7)" stroke-width="2" stroke-linecap="round"/>
        <!-- Index 6h -->
        <line x1="100" y1="178" x2="100" y2="166" stroke="rgba(180,150,90,0.7)" stroke-width="2" stroke-linecap="round"/>
        <!-- Index 9h -->
        <line x1="34" y1="100" x2="46" y2="100" stroke="rgba(180,150,90,0.7)" stroke-width="2" stroke-linecap="round"/>
        <!-- Aiguille minute -->
        <line
          class="varek-hand-minute"
          x1="100" y1="100"
          x2="100" y2="32"
          stroke="#f2ede5"
          stroke-width="1.5"
          stroke-linecap="round"
          transform-origin="100 100"
        />
        <!-- Aiguille heure -->
        <line
          class="varek-hand-hour"
          x1="100" y1="100"
          x2="100" y2="50"
          stroke="#f2ede5"
          stroke-width="2.5"
          stroke-linecap="round"
          transform-origin="100 100"
        />
        <!-- Aiguille seconde -->
        <line
          class="varek-hand-second"
          x1="100" y1="115"
          x2="100" y2="28"
          stroke="#b4965a"
          stroke-width="0.8"
          stroke-linecap="round"
          transform-origin="100 100"
        />
        <!-- Pivot central -->
        <circle cx="100" cy="100" r="4" fill="#b4965a"/>
        <circle cx="100" cy="100" r="1.5" fill="#f2ede5"/>
      </svg>
    `;

    wrapper.style.position = 'relative';
    wrapper.appendChild(overlay);

    // Animation
    let animFrame;
    let startTime = null;
    let isHovering = false;
    let currentSecAngle = 0;
    let currentMinAngle = -60; // Position 10h10
    let currentHourAngle = 60;

    function animate(timestamp) {
      if (!startTime) startTime = timestamp;
      const elapsed = (timestamp - startTime) / 1000; // secondes

      // Tourne plus vite au survol
      const speed = isHovering ? 3 : 0.5;

      currentSecAngle += speed * 6; // 6 deg/sec
      currentMinAngle += speed * 0.1; // 0.1 deg/sec
      currentHourAngle += speed * 0.00833;

      const secHand = overlay.querySelector('.varek-hand-second');
      const minHand = overlay.querySelector('.varek-hand-minute');
      const hourHand = overlay.querySelector('.varek-hand-hour');

      if (secHand) secHand.setAttribute('transform', `rotate(${currentSecAngle}, 100, 100)`);
      if (minHand) minHand.setAttribute('transform', `rotate(${currentMinAngle}, 100, 100)`);
      if (hourHand) hourHand.setAttribute('transform', `rotate(${currentHourAngle}, 100, 100)`);

      animFrame = requestAnimationFrame(animate);
    }

    // Demarrer l'animation en permanence (lente) et accelrer au survol
    animFrame = requestAnimationFrame(animate);

    wrapper.addEventListener('mouseenter', function () {
      isHovering = true;
      overlay.style.opacity = '1';
    });

    wrapper.addEventListener('mouseleave', function () {
      isHovering = false;
      overlay.style.opacity = '0';
    });
  });

});